// Email -> account lookup that does not require listing the Users collection.
//
// Directory/{sha256(lowercased email)} = { uid, name }
// Each account writes only its own entry (enforced by the Firestore rules), and other
// accounts may fetch an entry by key but never list the collection. The entry holds no
// email: to find someone you must already know their exact address.

export function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}

export async function emailKey(email) {
  const normalized = normalizeEmail(email);
  const bytes = new TextEncoder().encode(normalized);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join("");
}

export async function ensureDirectoryEntry(db, user, name) {
  if (!user || !user.email) return null;
  const key = await emailKey(user.email);
  const entry = { uid: user.uid, name: name || user.displayName || "" };
  await db.collection("Directory").doc(key).set(entry);
  return key;
}

/** Resolve an email to { id, email, name } or null. */
export async function lookupByEmail(db, email) {
  const normalized = normalizeEmail(email);
  if (!normalized) return null;
  const key = await emailKey(normalized);
  const doc = await db.collection("Directory").doc(key).get();
  if (doc.exists && doc.data() && doc.data().uid) {
    const d = doc.data();
    return { id: d.uid, email: normalized, name: d.name || "" };
  }
  return null;
}
